module.exports = __webpack_public_path__ + "static/media/logo_sm.d21f9ec8.png";